import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'balint-sessions',
    component: () => import(/* webpackChunkName: "balint-sessions" */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: '',
            name: 'balint-session-index',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.balint-sessions-index',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "balint-sessions-index" */ '@/modules/admin/balint-sessions/views/Index.vue')
        },
        {
            path: 'create',
            name: 'balint-session-create',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [   
                    {
                        route: {
                            name: 'balint-session-index',
                        },
                        transKey: 'breadcrumbs.balint-sessions-index',
                        isActive: false,
                    },                
                    {                           
                        transKey: 'breadcrumbs.balint-sessions-create',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "balint-sessions-create" */ '@/modules/admin/balint-sessions/views/Create.vue')
        },
        {
            path: 'edit/:id',
            name: 'balint-session-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [     
                    {
                        route: {
                            name: 'balint-session-index',
                        },
                        transKey: 'breadcrumbs.balint-sessions-index',
                        isActive: false,
                    },           
                    {                           
                        transKey: 'breadcrumbs.balint-sessions-edit',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "balint-sessions-edit" */ '@/modules/admin/balint-sessions/views/Create.vue')
        },
        {
            path: 'detail/:user_id',
            name: 'balint-session-detail',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [     
                    {
                        route: {
                            name: 'balint-session-index',
                        },
                        transKey: 'breadcrumbs.balint-sessions-index',
                        isActive: false,
                    },           
                    {                           
                        transKey: 'breadcrumbs.balint-sessions-detail',
                        isActive: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "balint-sessions-detail" */ '@/modules/admin/balint-sessions/views/Detail.vue')
        }
    ]
}